export function kgToPounds(kg: number) {
  return kg * 2.20462;
}
